import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import { useNavigate } from 'react-router-dom';

export const AccessDenied = () => {
  const navigate = useNavigate();

  return (
    <Paper
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '62vh',
        textAlign: 'center',
        p: { xs: 3, sm: 6 },
        borderRadius: '26px',
        background: 'linear-gradient(160deg, rgba(255,255,255,0.82), rgba(255,255,255,0.5))',
      }}>
      <Box
        sx={{
          width: 96,
          height: 96,
          borderRadius: '50%',
          display: 'grid',
          placeItems: 'center',
          mb: 3,
          background: 'linear-gradient(150deg, rgba(226,112,138,0.18), rgba(124,108,240,0.14))',
          border: '1px solid rgba(226,112,138,0.24)',
          boxShadow: '0 12px 30px rgba(226,112,138,0.18)',
        }}>
        <LockIcon sx={{ fontSize: 44, color: 'error.main' }} />
      </Box>

      <Typography variant='h5' sx={{ mb: 1.5, fontWeight: 800, letterSpacing: '-0.02em' }}>
        Acceso denegado
      </Typography>

      <Typography sx={{ color: 'text.secondary', mb: 4, maxWidth: 420, fontSize: '0.875rem' }}>
        Lo sentimos, actualmente no tienes permisos para acceder a esta sección.
      </Typography>

      <Button variant='contained' color='primary' onClick={() => navigate('/home')}>
        Regresar a la página principal
      </Button>
    </Paper>
  );
};
